/**
 * ISS-019 — 한국 휴대폰 번호 입력 포맷팅·검증 유틸.
 *
 * - `formatPhoneInput(value)` — input onChange 에서 실시간 포맷팅 (숫자만 추출 후 자동 하이픈)
 * - `isValidPhone(value)` — 저장 직전 최종 검증 (010-XXXX-XXXX 포맷)
 */

/** 숫자만 추출 후 자릿수에 따라 하이픈 자동 삽입. 비숫자 문자는 모두 버려진다. */
export function formatPhoneInput(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
}

/** 최종 포맷 검증: 010-XXXX-XXXX */
export function isValidPhone(value: string): boolean {
  return /^010-\d{4}-\d{4}$/.test(value);
}

